import { useState } from "react";
import api from "../../api";
import { getSubgridLayerId, setSubgridLayerId } from "../../lib/subgridLayer";

// Season subgrid layer selector + one-click "create this year's copy" (Status -> Not Treated).
export default function SubgridLayerSettings() {
  const [layerId, setLayerId] = useState(getSubgridLayerId());
  const [state, setState] = useState<"idle" | "busy" | "ok" | "error">("idle");
  const [message, setMessage] = useState("");

  const save = (id: string) => {
    setLayerId(id);
    setSubgridLayerId(id.trim());
  };

  const cloneLayer = async () => {
    const title = `Treatment Subgrid ${new Date().getFullYear()}`;
    if (!window.confirm(`Create "${title}" as a copy of the master subgrid layer with all Status set to "Not Treated"?`)) return;
    setState("busy");
    try {
      const res = await api.post("/clone-subgrid-layer", { new_title: title });
      save(res.data.new_layer_id);
      setState("ok");
      setMessage(`Created "${res.data.title}" (${res.data.new_layer_id}) — now in use.`);
    } catch (err: any) {
      setState("error");
      setMessage(err?.response?.data?.message || err.message);
    }
  };

  return (
    <div className="panel-inset space-y-2">
      <div className="text-xs font-semibold">Season subgrid layer (this year's copy)</div>
      <div className="flex gap-2 flex-wrap">
        <input
          value={layerId}
          onChange={(e) => save(e.target.value)}
          placeholder="AGOL item ID — empty = master layer"
          className="flex-1 min-w-[220px] border border-line-strong rounded-sm2 px-2 py-1.5 text-sm font-mono"
        />
        <button className="btn-ghost !py-1.5 text-xs" onClick={cloneLayer} disabled={state === "busy"}>
          {state === "busy" ? "Cloning…" : "Create this year's copy"}
        </button>
      </div>
      {state === "ok" && <p className="text-brand-deep text-xs font-semibold">✓ {message}</p>}
      {state === "error" && <p className="text-wnv text-xs font-semibold">✗ {message}</p>}
    </div>
  );
}
